import { currencies, Currency } from "../lib/currency";

export default function CurrencySwitcher({ value, onChange }: { value: Currency; onChange: (value: Currency) => void }) {
  return (
    <select className="rounded-md border border-slate-200 bg-white px-2 py-2 text-sm" value={value} onChange={(e) => onChange(e.target.value as Currency)}>
      {Object.keys(currencies).map((code) => <option key={code} value={code}>{code}</option>)}
    </select>
  );
}
